<template>
	
	<div class="alert_dialog" v-if="displayed">
		<div class="inner">			
			<div class="title">{{title}}</div>
			<div class="msg" v-html="msg"></div>
			<div class="btn">
				<button class="block ok" ref="ok" @click="ok()">Ok</button>
			</div>
		</div>
	</div>
	
</template>

<script>
  
	export default {
		name: 'AlertDialog',
		inject: [],
		components: {
			
		},
		data() {
			return {
				displayed: false,
				title: 'Titel',
				msg: 'Nachricht',
				cb_ok: undefined 
			}
		},
		methods: {
			
			show(title, msg, cb_ok) {
				
				this.title = title;
				this.msg = msg;
				this.cb_ok = cb_ok;
				
				this.displayed = true;

				this.$nextTick(() => {

					this.$refs.ok.focus();

				});

			},
			
			ok() {

				this.displayed = false;

				if (this.cb_ok !== undefined) {

					this.cb_ok();

				}
				
			}
			
		},
		mounted() {



		}
	}

</script>

<style lang="scss">
	
	.alert_dialog { z-index:101; position:fixed; left:0; top:0; width:100vw; height:100vh; background-color:rgba(0, 0, 0, 0.5); display:flex; justify-content:center; align-items:center;
		.inner { background-color:#FFFFFF; border-radius:10px; width:300px; display:flex; flex-direction:column; justify-content:stretch; align-items:stretch; overflow:hidden;
			.title { width:100%; padding:15px 0; text-align:center; font-weight:bold; font-size:1.2em; }
			.msg { padding:0 15px 30px 15px; text-align:center; flex-grow:1; }
			.btn { width:100%; border-top:1px solid #999999; display:flex; justify-content:stretch; flex-direction:row;
				& > button { flex-grow:1; text-align:center; height:50px; width:100%; display:flex; justify-content:center; align-items:center; cursor:pointer; color: rgba(59, 130, 246); font-weight:bold;
					appearance:none; -webkit-appearance:none;
					&:focus { outline:none; }
					&:hover { background-color:rgba(59, 130, 246); color:#FFFFFF; }
				}
				& > div:nth-child(1) { border-right:1px solid #999999; }
			}
		}
	}

</style>